import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { fieldSegment } from "../lib/ast-path.js";
import { FIELD_LIST_THRESHOLD, selectVisibleFields } from "../lib/field-list-view.js";
import { FieldTreeProvider, useFieldTreeContext } from "./field-tree-context.js";
import { FieldTreeNode } from "./field-tree-node.js";
import { isFieldSelected } from "../lib/field-selection.js";
const FieldTreeList = (t0) => {
  const $ = c(29);
  const {
    type,
    path
  } = t0;
  const {
    doc,
    target
  } = useFieldTreeContext();
  const [expanded, setExpanded] = useState(false);
  const [filter, setFilter] = useState("");
  let hiddenCount;
  let indent;
  let t1;
  let t2;
  let t3;
  if ($[0] !== doc || $[1] !== expanded || $[2] !== filter || $[3] !== path || $[4] !== target || $[5] !== type) {
    const fields = Object.values(type.getFields());
    const isLong = fields.length > FIELD_LIST_THRESHOLD;
    indent = path.length * 12;
    let t42;
    if ($[11] !== doc || $[12] !== path || $[13] !== target) {
      t42 = (fieldName) => isFieldSelected(doc, [...path, fieldSegment(fieldName)], target);
      $[11] = doc;
      $[12] = path;
      $[13] = target;
      $[14] = t42;
    } else {
      t42 = $[14];
    }
    const isSelected = t42;
    const {
      visible,
      hiddenCount: t52
    } = selectVisibleFields({
      fields,
      isSelected,
      threshold: FIELD_LIST_THRESHOLD,
      expanded,
      filter
    });
    hiddenCount = t52;
    t1 = "graphiql-qb-field-tree";
    if ($[15] !== filter || $[16] !== indent || $[17] !== isLong) {
      t2 = isLong && /* @__PURE__ */ jsx("input", { type: "text", className: "graphiql-qb-field-filter", style: {
        marginLeft: indent
      }, "aria-label": "Filter fields", placeholder: "Filter fields…", value: filter, onChange: (e) => setFilter(e.target.value) });
      $[15] = filter;
      $[16] = indent;
      $[17] = isLong;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    let t6;
    if ($[19] !== path) {
      t6 = (field) => /* @__PURE__ */ jsx(FieldTreeNode, { field, path }, field.name);
      $[19] = path;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t3 = visible.map(t6);
    $[0] = doc;
    $[1] = expanded;
    $[2] = filter;
    $[3] = path;
    $[4] = target;
    $[5] = type;
    $[6] = hiddenCount;
    $[7] = indent;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    hiddenCount = $[6];
    indent = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[21] !== hiddenCount || $[22] !== indent) {
    t4 = hiddenCount > 0 && /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-qb-show-more", style: {
      marginLeft: indent
    }, onClick: () => setExpanded(true), children: [
      "...",
      hiddenCount,
      " more fields"
    ] });
    $[21] = hiddenCount;
    $[22] = indent;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  let t5;
  if ($[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4) {
    t5 = /* @__PURE__ */ jsxs("div", { className: t1, children: [
      t2,
      t3,
      t4
    ] });
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
};
const FieldTree = (t0) => {
  const $ = c(21);
  const {
    type,
    path,
    doc,
    schema,
    target,
    cursorPath,
    onToggle,
    onSetArg,
    onPromoteArg,
    onDemoteArg,
    onAddInlineFragment,
    onRemoveInlineFragment,
    onRemoveFragmentSpread,
    onExtractFragment,
    onRenameFragment,
    onFocusFragment
  } = t0;
  let t1;
  if ($[0] !== cursorPath || $[1] !== doc || $[2] !== onAddInlineFragment || $[3] !== onDemoteArg || $[4] !== onExtractFragment || $[5] !== onFocusFragment || $[6] !== onPromoteArg || $[7] !== onRemoveFragmentSpread || $[8] !== onRemoveInlineFragment || $[9] !== onRenameFragment || $[10] !== onSetArg || $[11] !== onToggle || $[12] !== schema || $[13] !== target) {
    t1 = {
      doc,
      schema,
      target,
      cursorPath,
      onToggle,
      onSetArg,
      onPromoteArg,
      onDemoteArg,
      onAddInlineFragment,
      onRemoveInlineFragment,
      onRemoveFragmentSpread,
      onExtractFragment,
      onRenameFragment,
      onFocusFragment
    };
    $[0] = cursorPath;
    $[1] = doc;
    $[2] = onAddInlineFragment;
    $[3] = onDemoteArg;
    $[4] = onExtractFragment;
    $[5] = onFocusFragment;
    $[6] = onPromoteArg;
    $[7] = onRemoveFragmentSpread;
    $[8] = onRemoveInlineFragment;
    $[9] = onRenameFragment;
    $[10] = onSetArg;
    $[11] = onToggle;
    $[12] = schema;
    $[13] = target;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  const contextValue = t1;
  let t2;
  if ($[15] !== path || $[16] !== type) {
    t2 = /* @__PURE__ */ jsx(FieldTreeList, { type, path });
    $[15] = path;
    $[16] = type;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== contextValue || $[19] !== t2) {
    t3 = /* @__PURE__ */ jsx(FieldTreeProvider, { value: contextValue, children: t2 });
    $[18] = contextValue;
    $[19] = t2;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  return t3;
};
export {
  FieldTree,
  FieldTreeList
};
//# sourceMappingURL=field-tree.js.map
